var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-alert',{staticStyle:{"margin-bottom":"20px"},attrs:{"message":_vm.$t('compute.text_1031'),"type":"warning"}}),_c('direction-list',{attrs:{"type":_vm.getParams.type,"id":_vm.getParams.id,"isRead":_vm.isRead}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }